import { useState } from "react";
import { NodeTestRunInstance } from "../../types/workflow";

const useTestRunInstances = () => {
    const [testRunInstances, setTestRunInstances] = useState<Record<string, NodeTestRunInstance>>({});
    
    return {
        testRunInstances,
        setTestRunInstances,
    }
}

export default useTestRunInstances;